import { Badge, Input, TextField } from "@mui/material";
import { Container, Row } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import React, { Fragment, useEffect, useRef, useState } from "react";

import { fetchCartSize } from "../../actions/global";
import { fetchLogout } from "../../actions/user";
import i18next from "i18next";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useGlobalModal } from "../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { CANONICAL_SALES_PATH } from "../../constants/salesRoutes";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 0,
    top: 20,
  },
}));

const Header = () => {
  const location = useLocation();
  const { i18n, t } = useTranslation();

  // const [showModal, toggleModal] = useModalToggle(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [user, setUser] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dropdownMenuRef = useRef(null);
  const iconRef = useRef(null);
  const params = new URLSearchParams(location.search);
  const loginModal = params.get("login") || false;

  const { openModal } = useGlobalModal();
  const [showMenu, setShowMenu] = useState(false);

  const { userData } = useSelector((state) => state.userReducer);
  const { cartSize, mySubscription } = useSelector(
    (state) => state.globalReducer
  );
  const hasActiveSubscription = mySubscription?.status === "ACTIVE";

  useEffect(() => {
    if (userData?.firstName) dispatch(fetchCartSize());
  }, [dispatch]);

  useEffect(() => {
    document.body.classList.toggle("mobile-menu-open", showMenu);

    return () => {
      document.body.classList.remove("mobile-menu-open");
    };
  }, [showMenu]);

  useEffect(() => {
    if (loginModal) openLoginForm(true);
  }, [loginModal]);

  const openLoginForm = () => openModal("login");
  const openCartFuncion = () => {
    openModal("cart");
  };

  const logoutFunction = () => {
    dispatch(fetchLogout());
  };

  useEffect(() => {
    setUser(userData);
  }, [userData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showMenu &&
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [showMenu]);

  const handlerChangeLanguage = (language) => {
    i18next.changeLanguage(language);
    window.location.reload();
  };

  return (
    <div className="header-main">
      <div className="header-content-main-holder">
        <Container>
          <Row>
            <div className="header-content-main">
              <div className="header-item-logo">
                <div className="header-logo">
                  <NavLink to="/" end>
                    {" "}
                    {/* end da / ne bude aktivan svuda */}
                    <img
                      src="/images/logo-kat.png"
                      className="img-fluid"
                      alt="Katarza"
                    />
                  </NavLink>
                </div>
              </div>

              <div className="header-item-items">
                <div className="header-item-item menu-header-item">
                  {!showSearch ? (
                    <img
                      src="/images/icon-search.png"
                      alt="search"
                      className="img-fluid"
                      onClick={() => setShowSearch(true)}
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <div className="landing-page-search-input">
                      <Input
                        type="text"
                        className="input-text-type"
                        autoFocus
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onBlur={() => setShowSearch(false)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && searchQuery.trim() !== "") {
                            navigate(
                              `/search?q=${encodeURIComponent(
                                searchQuery.trim()
                              )}`
                            );
                            setSearchQuery("");
                            setShowSearch(false);
                          }
                        }}
                      />
                    </div>
                  )}
                </div>

                <div
                  className="header-item-item"
                  onClick={() => navigate("/mikrokat")}
                >
                  <span
                    className={
                      "menu-link" +
                      (location.pathname.includes("mikrokat")
                        ? " is-active"
                        : "")
                    }
                  >
                    {t("header.mikrokat")}
                  </span>
                </div>
                <div
                  className="header-item-item"
                  onClick={() => navigate("/minikat")}
                >
                  <span
                    className={
                      "menu-link" +
                      (location.pathname.includes("/minikat")
                        ? " is-active"
                        : "")
                    }
                  >
                    {t("header.minikat")}
                  </span>
                </div>

                <div
                  className="header-item-item"
                  onClick={() => navigate("/masterkat")}
                >
                  <span
                    className={
                      "menu-link" +
                      (location.pathname.includes("masterkat")
                        ? " is-active"
                        : "")
                    }
                  >
                    {t("header.masterkat")}
                  </span>
                </div>

                {!hasActiveSubscription && (
                  <Link
                    className="header-item-item header-item-item-subscribe"
                    to={CANONICAL_SALES_PATH}
                  >
                    {t("subscription.subscribeCta")}
                  </Link>
                )}

                {user?.firstName ? (
                  <Fragment>
                    <div className="header-item-desktop">
                      <NavLink to="/profile/0">
                        <img
                          src="/images/profile.png"
                          alt="profile"
                          className="img-fluid"
                        />
                      </NavLink>
                    </div>
                  </Fragment>
                ) : (
                  <div
                    className="header-item-item"
                    onClick={() => openLoginForm(true)}
                  >
                    {t("global.login")}
                  </div>
                )}

                <div className="language-header-item-desktop header-item-desktop">
                  {i18n.language === "en" ? (
                    <div
                      className="header-item-item header-item-item-language"
                      onClick={() => handlerChangeLanguage("sr")}
                    >
                      EN
                    </div>
                  ) : (
                    <div
                      className="header-item-item header-item-item-language"
                      onClick={() => handlerChangeLanguage("en")}
                    >
                      SR
                    </div>
                  )}
                </div>

                <div className="header-item-item menu-header-item dropdown-menu-holder">
                  {showMenu ? (
                    <img
                      src="/images/close-2.png"
                      alt="menu"
                      className="img-fluid"
                      ref={iconRef}
                      onClick={() => setShowMenu(false)}
                    />
                  ) : (
                    <img
                      src="/images/menu.png"
                      alt="menu"
                      className="img-fluid"
                      ref={iconRef}
                      onClick={() => setShowMenu(true)}
                    />
                  )}

                  <div
                    ref={dropdownMenuRef}
                    className={`header-menu-holder ${showMenu ? "show" : ""}${
                      !user?.firstName ? " logout-holder-menu" : ""
                    }`}
                  >
                    <div className="header-item-item header-menu-item-mobile-item specific-mobile-item-menu">
                      <div className="header-menu-items-mobile-multiple">
                        {user?.firstName && (
                          <div className="header-multiple-item">
                            <NavLink to="/profile/0">
                              <img
                                src="/images/profile.png"
                                alt="profile"
                                className="img-fluid"
                              />
                            </NavLink>
                          </div>
                        )}
                        <div className="header-multiple-item">
                          {i18n.language === "en" ? (
                            <div
                              className="header-item-item header-item-item-language"
                              onClick={() => handlerChangeLanguage("sr")}
                            >
                              EN
                            </div>
                          ) : (
                            <div
                              className="header-item-item header-item-item-language"
                              onClick={() => handlerChangeLanguage("en")}
                            >
                              SR
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="header-menu-item header-menu-item-mobile-item"
                      onClick={() => { setShowMenu(false); navigate("/mikrokat"); }}
                    >
                      {t("header.mikrokat")}
                    </div>
                    <div
                      className="header-menu-item header-menu-item-mobile-item"
                      onClick={() => { setShowMenu(false); navigate("/minikat"); }}
                    >
                      {t("header.minikat")}
                    </div>
                    <div
                      className="header-menu-item header-menu-item-mobile-item"
                      onClick={() => { setShowMenu(false); navigate("/masterkat"); }}
                    >
                      {t("header.masterkat")}
                    </div>
                    {user?.firstName && (
                      <Fragment>
                        <div
                          className="header-menu-item"
                          onClick={() => setShowMenu(false)}
                        >
                          <Link to="/profile/4">{t("header.saved")}</Link>
                        </div>
                        <div
                          className="header-menu-item"
                          onClick={() => setShowMenu(false)}
                        >
                          <Link to="/reels">{t("footer.quickLinks.reel")}</Link>
                        </div>
                        <div
                          className="header-menu-item"
                          onClick={() => setShowMenu(false)}
                        >
                          <Link to="/about">{t("header.about")}</Link>
                        </div>

                        <div
                          className="header-menu-item"
                          onClick={() => setShowMenu(false)}
                        >
                          <Link to="/contact-instructor">
                            {t("header.becomeInstructor")}
                          </Link>
                        </div>
                        <div
                          className="header-menu-item"
                          onClick={() => logoutFunction()}
                        >
                          {t("header.logout")}
                        </div>
                      </Fragment>
                    )}
                    {!user?.firstName && (
                      <Fragment>
                        <div
                          className="header-menu-item"
                          onClick={() => setShowMenu(false)}
                        >
                          <Link to="/about">{t("header.about")}</Link>
                        </div>

                        <div
                          className="header-menu-item"
                          onClick={() => setShowMenu(false)}
                        >
                          <Link to="/contact-instructor">
                            {t("header.becomeInstructor")}
                          </Link>
                        </div>
                        <div
                          className="header-menu-item header-menu-item-login-mobile"
                          onClick={() => openLoginForm(true)}
                        >
                          {t("global.login")}
                        </div>
                      </Fragment>
                    )}
                    {!hasActiveSubscription && (
                      <Link
                        className="header-menu-item header-menu-item-mobile-item"
                        to={CANONICAL_SALES_PATH}
                        onClick={() => setShowMenu(false)}
                      >
                        {t("subscription.subscribeCta")}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Header;
